"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.link = void 0;
const _ = __importStar(require("lodash"));
const helpers_1 = require("../helpers");
function getvalue(data, value) {
    if (_.startsWith(value, '$rowdata')) {
        return _.get(data, value
            .split('.')
            .slice(1)
            .join('.'));
    }
    return value;
}
function link(opts) {
    if (!opts) {
        throw new TypeError('Options is required.');
    }
    if (!opts.href && !opts.hrefField) {
        throw new TypeError('linkFormatter: Missing `href` or `hrefField` parameter.');
    }
    const valueGetter = opts.displayMember
        ? (value, data) => _.get(data, opts.displayMember)
        : (value) => value;
    const attrs = { tabindex: 0, ...opts.attrs };
    const getHref = opts.href
        ? _.template(opts.href)
        : opts.hrefField
            ? (data) => data[opts.hrefField]
            : null;
    if (opts.className) {
        attrs['class'] = opts.className;
    }
    if (opts.href === '#') {
        attrs['href'] = '#';
        attrs['onclick'] = 'return false;';
    }
    const linkFormatter = (row, cell, value, columnDef, data) => {
        if (value == null)
            return '';
        value = valueGetter(value, data);
        return (0, helpers_1.createElementText)('a', {
            href: getHref ? getHref(data) : null,
            ...attrs,
            'data-value': value
        }, value);
    };
    linkFormatter.exportRawData = true;
    return linkFormatter;
}
exports.link = link;
//# sourceMappingURL=link.js.map